<template>
  <div>
    <a v-if="isAppointment" :href="appointmentLink" target="_blank" class="transferPaymentLink body-2">
      {{ item.appointment.code }}
    </a>

    <a v-if="isMission" :href="missionLink" target="_blank" class="transferPaymentLink body-2">
      {{ item.mission.name }}
    </a>

    <div v-if="item.appointment === null && item.mission === null">
      <span class="d-block body-2 pl-3">
        {{item.created_by.name}}
        <span class="d-block caption grey--text">
          {{ item.created_by.username }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransferPaymentLink',

  props: {
    item: {
      type: Object,
      required: true,
    }
  },

  computed: {
    isAppointment() {
      return this.item.appointment !== null
    },

    appointmentLink() {
      return `/admin-appointment/${this.item?.appointment?.id}`
    },

    isMission() {
      return this.item.mission !== null
    },

    missionLink() {
      return `/mission-progress/${this.item?.mission?.id}`
    },
  }
}
</script>
